import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { GoldRule } from './GoldRule';
import { reviews } from './data';
export function Reviews() {
  return <section id="resenas" className="max-w-2xl mx-auto px-6 pt-16 scroll-mt-24" data-id="element-317" data-mp="2mbyonluibhsj">
      <GoldRule data-id="element-318" data-mp="2me1p6ztactbi">Lo que dicen ellas</GoldRule>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.7
    }} data-id="element-319" data-mp="2rbtfjpea87dl">
        <div className="flex items-center gap-2 mb-3" data-id="element-320" data-mp="309x4kvoh7ma5">
          <span className="flex items-center gap-0.5 text-champagne" data-id="element-321" data-mp="351ojua26m5kz">
            {Array.from({
            length: 5
          }).map((_, i) => <Star key={i} className="w-3 h-3 fill-current" strokeWidth={0} data-id="element-322" data-mp="39zyhqsfajkaa" data-mpi={i} />)}
          </span>
          <p className="font-body font-semibold text-[11px] tracking-[3px] uppercase text-champagne-deep" data-id="element-323" data-mp="3f1ns05uovtxb">
            Reseñas Verificadas · Google
          </p>
        </div>
        <h2 className="font-serif text-dark text-3xl sm:text-4xl leading-tight mb-6" data-id="element-324" data-mp="2rd70kcdaccrv">
          Resultados reales.
          <br data-id="element-325" data-mp="2mcj77k1l3juh" />
          <em className="italic text-gold" data-id="element-326" data-mp="2mbzq25jrczhi">Palabras reales.</em>
        </h2>
      </motion.div>

      <div className="space-y-5" data-id="element-327" data-mp="2hf9dhs75wm0u">
        {reviews.map((review, i) => <motion.div key={review.meta} initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        delay: i * 0.08
      }} className="bg-cream border-t-2 border-metallic-border p-6 sm:p-7" data-id="element-328" data-mp="2dde9uh1rdwjw" data-mpi={i}>
            <span className="flex items-center gap-0.5 text-champagne mb-2" data-id="element-329" data-mp="30bizr2s7wivx">
              {Array.from({
            length: 5
          }).map((_, s) => <Star key={s} className="w-3.5 h-3.5 fill-current" strokeWidth={0} data-id="element-330" data-mp="3stek6syrf9zv" data-mpi={s} />)}
            </span>
            <p className="font-serif italic text-dark text-base sm:text-lg leading-[1.65] mb-3" data-id="element-331" data-mp="3o2elpj9zsjv9">
              {review.text}
            </p>
            <div className="font-body font-medium text-[11px] tracking-[2px] uppercase text-soft" data-id="element-332" data-mp="1m5w8oevmftvv">
              {review.meta}
            </div>
            <div className="font-body font-light text-[11px] text-champagne-deep mt-0.5" data-id="element-333" data-mp="1cfukln39qbgy">
              {review.service}
            </div>
            <div className="font-serif text-champagne-deep text-base mt-1.5" data-id="element-334" data-mp="1hdcx1nghv8tp">{review.amount}</div>
          </motion.div>)}
      </div>
    </section>;
}